export default [
  {
    key: 'checkbox',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  { label: 'メールアドレス', key: 'email', _style: 'min-width:140px' },
  { label: 'ユーザ名 ', key: 'account_name', _style: 'min-width:140px' },
  { label: 'デバイス名 ', key: 'device_name', _style: 'min-width:140px' },
  { label: 'Macアドレス ', key: 'mac', _style: 'min-width:140px' },
  { label: 'モデル名', key: 'model', _style: 'min-width:140px' },
  { label: '連携日時', key: 'created_at', _style: 'min-width:140px' },
]
